import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useProvince } from "@/contexts/ProvinceContext";
import { Cloud, CloudRain, Sun, CloudSun, Snowflake, Wind, Droplets } from "lucide-react";

const ICONS = {
  sunny: Sun, partly_cloudy: CloudSun, cloudy: Cloud, rainy: CloudRain, snowy: Snowflake,
};

export default function WeatherBar() {
  const { selected } = useProvince();
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!selected?.id) return;
    api.get(`/weather?province_id=${selected.id}`).then((r) => setData(r.data)).catch(() => {});
  }, [selected?.id]);
  if (!data || data.enabled === false || data.temperature == null) {
    return null;
  }
  const Icon = ICONS[data.condition] || Cloud;
  return (
    <div data-testid="weather-bar" className="bg-gradient-to-r from-blue-50 to-cyan-50 border-b border-blue-100">
      <div className="max-w-7xl mx-auto px-3 h-7 flex items-center justify-between text-xs">
        <div className="flex items-center gap-2 min-w-0">
          <Icon className="w-3.5 h-3.5 text-blue-600 shrink-0" />
          <span className="font-semibold text-gray-700">{selected?.name}</span>
          <span className="font-black text-[#0b0b0d]">{data.temperature}°C</span>
          {data.label && <span className="text-gray-500 truncate hidden sm:inline">{data.label}</span>}
          {data.high != null && data.low != null && (
            <span className="text-gray-400 text-[11px] hidden md:inline">↑{data.high}° / ↓{data.low}°</span>
          )}
        </div>
        <div className="hidden md:flex items-center gap-3 text-gray-600 text-[11px]">
          {data.humidity != null && <span className="inline-flex items-center gap-0.5"><Droplets className="w-3 h-3" /> %{data.humidity}</span>}
          {data.wind_speed != null && <span className="inline-flex items-center gap-0.5"><Wind className="w-3 h-3" /> {data.wind_speed} km/sa</span>}
        </div>
      </div>
    </div>
  );
}
